import { BaseContainerModel } from '../base-container.model';
import { bl_mrp_job_order_hdr_RowClass, bl_inv_current_location_stock_balance_RowInterface } from '../../dbschema';

export class MrpJobOrderItemStockContainerModel extends BaseContainerModel {
  bl_mrp_job_order_hdr: bl_mrp_job_order_hdr_RowClass = new bl_mrp_job_order_hdr_RowClass();
  bl_inv_current_location_stock_balances: bl_inv_current_location_stock_balance_RowInterface[] = [];
}
